import React, { useMemo } from 'react';
import { useGetTopUnoptimizedTemplates } from '../../../query/template';
import { Table } from '../../../components/ui';
import TemplateStatistic from '../../../components/ui/TemplateStatistic';

export default function TopUnoptimizedTemplates() {
  const { data, isLoading } = useGetTopUnoptimizedTemplates();
  const tableColumns = useMemo(() => {
    return [
      {
        title: 'Id',
        dataIndex: 'id',
        key: 'id',
        render: (row, { emailTemplate }) => emailTemplate.id,
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        render: (row, { emailTemplate }) => emailTemplate.name,
      },
      {
        title: 'Errors',
        dataIndex: 'errors',
        key: 'errors',
        render: (row, { numOfErrors }) => (
          <TemplateStatistic count={numOfErrors} type="error" />
        ),
      },
      {
        title: 'Warnings',
        dataIndex: 'warnings',
        key: 'warnings',
        render: (row, { numOfWarnings }) => (
          <TemplateStatistic count={numOfWarnings} type="warning" />
        ),
      },
    ];
  }, []);
  return (
    <>
      <Table
        columns={tableColumns}
        dataSource={data || []}
        loading={isLoading}
        rowKey="id"
      />
    </>
  );
}
